import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText, DollarSign, ArrowRightLeft, RefreshCw, Copy, CheckCircle2, XCircle } from "lucide-react";

const formatCurrency = (value) => {
  if (!value && value !== 0) return "-";
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
};

function OperacaoCard({ titulo, n, bruto, saldo, liberado, Icon, tone }) {
  const tones = {
    blue: { bg: "bg-blue-50", iconBg: "bg-blue-100", icon: "text-blue-600", liberado: "text-blue-700" },
    purple: { bg: "bg-purple-50", iconBg: "bg-purple-100", icon: "text-purple-600", liberado: "text-purple-700" },
  }[tone];
  const slug = titulo.toLowerCase().includes("portab") ? "portabilidade" : "refin";
  return (
    <Card className={tones.bg}>
      <CardContent className="pt-5 flex items-start gap-3">
        <div className={`p-3 rounded-lg ${tones.iconBg}`}>
          <Icon className={`h-5 w-5 ${tones.icon}`} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-muted-foreground">{titulo}</p>
          <p className="text-xs text-muted-foreground mb-1" data-testid={`rx-${slug}-contratos`}>{n ?? 0} contratos aprovados</p>
          <div className="space-y-0.5 text-xs">
            <div className="flex justify-between gap-2">
              <span className="text-muted-foreground">Total Bruto</span>
              <span className="font-semibold" data-testid={`rx-bruto-${slug}`}>{formatCurrency(bruto)}</span>
            </div>
            <div className="flex justify-between gap-2">
              <span className="text-muted-foreground">Saldo Devedor</span>
              <span className="font-semibold text-orange-600" data-testid={`rx-saldo-${slug}`}>{formatCurrency(saldo)}</span>
            </div>
            <div className="flex justify-between gap-2 border-t pt-1 mt-0.5">
              <span className="text-muted-foreground font-medium">Liberado</span>
              <span className={`text-base font-bold ${tones.liberado}`} data-testid={`rx-liberado-${slug}`}>{formatCurrency(liberado)}</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default function TotaisCliente({ rx, onCopiar }) {
  const r = rx || {};
  const total = r.total ?? 0;
  const aprovados = r.aprovados ?? 0;
  const reprovados = r.reprovados ?? 0;

  return (
    <div className="space-y-3" data-testid="raio-x-cliente">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h3 className="text-sm font-bold text-slate-700 flex items-center gap-2">
          <span className="inline-block h-4 w-1 rounded bg-primary" />
          Raio-X do Cliente
        </h3>
        <Button size="sm" variant="default" className="gap-1" onClick={onCopiar} data-testid="btn-copiar-rx">
          <Copy className="h-4 w-4" /> Copiar Raio-X (WhatsApp)
        </Button>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 items-stretch">
        <Card className="bg-slate-50">
          <CardContent className="pt-5 flex items-start gap-3">
            <div className="p-3 bg-slate-100 rounded-lg">
              <FileText className="h-5 w-5 text-slate-600" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Total Contratos</p>
              <p className="text-2xl font-bold" data-testid="rx-total-contratos">{total}</p>
              <div className="flex items-center gap-2 text-xs mt-0.5">
                <span className="inline-flex items-center gap-1 text-green-600 font-semibold" data-testid="rx-aprovados">
                  <CheckCircle2 className="h-3 w-3" /> {aprovados} aprov.
                </span>
                <span className="inline-flex items-center gap-1 text-red-500 font-semibold" data-testid="rx-reprovados">
                  <XCircle className="h-3 w-3" /> {reprovados} reprov.
                </span>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="bg-emerald-50">
          <CardContent className="pt-5 flex items-start gap-3">
            <div className="p-3 bg-emerald-100 rounded-lg">
              <DollarSign className="h-5 w-5 text-emerald-600" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Total Parcelas</p>
              <p className="text-2xl font-bold" data-testid="rx-total-parcelas">{formatCurrency(r.totalParcelas)}</p>
            </div>
          </CardContent>
        </Card>

        <OperacaoCard titulo="Liberado Portabilidade" n={r.nPort} bruto={r.brutoPort} saldo={r.saldoPort} liberado={r.libPort} Icon={ArrowRightLeft} tone="blue" />
        <OperacaoCard titulo="Liberado Refin" n={r.nRefin} bruto={r.brutoRefin} saldo={r.saldoRefin} liberado={r.libRefin} Icon={RefreshCw} tone="purple" />
      </div>
    </div>
  );
}
